import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitMembership = (data) =>
  api.post("/membership-applications", data).then((r) => r.data);

export const submitVendor = (data) =>
  api.post("/vendor-applications", data).then((r) => r.data);

export const submitInquiry = (data) =>
  api.post("/inquiries", data).then((r) => r.data);
